import { ObjectToDraw, SpriteAnimData } from '../types';
import P5 from 'p5';
import Entity from './entity';
import SpriteAnimationRenderer from '../spriteAnimationRenderer';
import GameMap from '../game/gameMap';
import TextParticle from '../particles/textParticle';

class GameItem implements Entity {
    NAME = 'coin';
    hash: string;
    x: number;
    y: number;
    oldX: number;
    oldY: number;
    vx: number = 0;
    vy: number = 0;
    isDead: boolean;
    spawnTime: number;
    anim: SpriteAnimationRenderer;
    hitbox: { w: 16; h: 32; };
    strength: number;
    damagable: boolean;
    action: Function;

    constructor(private type: string, sx: number, sy: number, velocity: number) {
        this.x = sx;
        this.y = sy;
        this.oldX = this.x-player.x;
        this.oldY = this.y-player.y;
        let angle = p5js.random(p5js.TWO_PI);
        this.vx = Math.cos(angle) * velocity;
        this.vy = Math.sin(angle) * velocity;
        this.isDead = false;
        this.spawnTime = p5js.millis();

        this.hitbox = {w: 16, h: 32};
        this.strength = 0;
        this.damagable = false;

        this.anim = new SpriteAnimationRenderer();
        
        if(this.type == 'coin'){
            this.anim.load('/assets/entities/items/coin/coin');
            this.action = () => {
                player.coins += 1;
                particles.push(new TextParticle(this.x, this.y, "+1 coin"));
            }
        }else if(this.type == 'heart'){
            this.anim.load('/assets/entities/items/heart/heart');
            this.action = () => {
                player.health += 20;
                if(player.health > 100){
                    player.health = 100;
                }
                particles.push(new TextParticle(this.x, this.y, "+20 hp"));
            }
        }else if(this.type == 'egg'){
            this.anim.load('/assets/entities/items/egg/egg');
            this.action = () => {
                player.health += 5;
                if(player.health > 100){
                    player.health = 100;
                }
                particles.push(new TextParticle(this.x, this.y, "+5 hp"));
            }
        }else{
            this.type = "";
            this.anim.load('/assets/entities/items/mistery/mistery');
            this.action = () => {
                particles.push(new TextParticle(this.x, this.y, "????"));
            }
        }

        // NAME/hash should reflect the actual item type (coin/heart/egg/mistery),
        // not be hardcoded to "coin" regardless of what this item actually is.
        this.NAME = this.type || 'mistery';
        this.hash = `${this.NAME}_${sx}_${sy}`;
    }

    init() {
        console.log('Coin initialized');
    }

    update() {
        if(this.isDead){
            return;
        }

        this.x += this.vx;
        this.y += this.vy;

        this.vx *= 0.9;
        this.vy *= 0.9;
        //particles.push(new Smoke(p5js, player, this.x, this.y, 1));

        //calculate the distance between the player and the coin
        let distance = p5js.dist(this.x, this.y, player.x, player.y);

        //magnet effect, coins will move towards the player
        if(distance < 128){
            let angle = p5js.atan2(player.y-this.y, player.x-this.x);
            this.vx += Math.cos(angle) * 1;
            this.vy += Math.sin(angle) * 1;
        }

        // check if the player is close enough to pick up the coin
        if(distance < 32){
            if(this.action){
                this.action();
            }
            this.kill();
        }
    }

    render(objectsToDraw: ObjectToDraw[]) {
        let posOnScreen = {x: this.x-player.x, y: this.y-player.y};

        if(posOnScreen.x < -buffer.width/2-64 || posOnScreen.x > buffer.width/2+64 || posOnScreen.y < -buffer.height/2-64 || posOnScreen.y > buffer.height/2+64){
            return;
        }

        if(showDebug){
            buffer.stroke(0, 0, 255);
            buffer.strokeWeight(1);
            buffer.noFill();
            buffer.rect(posOnScreen.x-this.hitbox.w/2, posOnScreen.y-this.hitbox.h, this.hitbox.w, this.hitbox.h);
        }


        buffer.noStroke();
        buffer.fill(0, 100);
        buffer.ellipse(posOnScreen.x, posOnScreen.y, 30, 15);

        this.anim.render(objectsToDraw, p5js.floor(posOnScreen.x), p5js.floor(posOnScreen.y), 0);

        this.oldX = posOnScreen.x;
        this.oldY = posOnScreen.y;
    }

    renderUI() {
        // nothing to render
    }

    isToBeRemoved() {
        return this.isDead;
    }

    kill() {
        this.isDead = true;
    }

    hit(){

    }

    getHash() {
        return this.hash;
    }

    // getPreviewImage(): P5.Image | null {
    //     return null;
    // }

    // getPreviewData() : SpriteAnimData | null {
    //     return {
    //         centerX: 8,
    //         centerY: 8,
    //         frameWidth: 16,
    //         frameHeight: 16,
    //         framesCount: 1,
    //         rotationCount: 1,
    //         images: [[Bullet.image]]
    //     };
    // }

    isInHitbox(x: number, y: number): boolean {
        return false;
    }
}

export default GameItem;